import { createTheme } from "@mui/material/styles";
import { indigo, pink } from "@mui/material/colors";

const theme = createTheme({
  palette: {
    primary: indigo,
    secondary: pink,
  },
});

export default theme;
